<p *ngIf="!results">
  No parcel was selected.
</p>

<div *ngIf="results">
  <div class="tab-pane fade active show" *ngIf="activity.model.hasMap">
    <!-- Added by amisha on 26-05-2026 to use a printable parcel map image
         because the live ArcGIS map surface does not render reliably in print preview. -->
    <img
      *ngIf="mapPrintImageUrl"
      class="print-map-image"
      [src]="mapPrintImageUrl"
      alt="Parcel map"
    />
    <app-esri-map
      #mapComp
      [class.hide-on-print]="!!mapPrintImageUrl"
      [mapServiceId]="activity.model.mapConfig.mapServiceId"
      [basemapName]="activity.model.mapConfig.basemapName"
      [initialExtent]="activity.model.mapConfig.initialExtent"
      [mapLayerOptions]="activity.model.mapConfig.layers"
      [showToc]="false"
      [allowZoom]="false"
      (mapLoaded)="onMapLoaded()"
      useSketchLayer="false"
    ></app-esri-map>
  </div>

  <div *ngIf="results && results.length > 0" style="background-color: white">
    <div style="overflow-x: auto;">
     <!-- @if(templateForPermitForm){ -->
    <table class="table">
      <tr
        *ngFor="let parcel of results; let isFirstRow = first"
        [ngClass]="{ RowHeaderCSS: isFirstRow }"
      >
        <td>{{ parcel.parcelID }}</td>
        <td>{{ parcel.address }}</td>
        <td>{{ parcel.city }}</td>
        <td>{{ parcel.ownerName }}</td>
        <td align="right">
          {{ isFirstRow ? parcel.acres : (parcel.acres | number: '1.3-3') }}
        </td>
      </tr>
    </table>

      <!-- }
  @else{
         <wm-common-table
  *ngIf="results && results.length > 0"
  [columns]="parcelTableColumns"
  [data]="trimResultsByColumns(results, parcelTableColumns)"
  tableClass="table"

></wm-common-table>
  } -->
  </div>
  </div>
</div>
